import { type FramesInitProps } from 'frames-react';

const CHECKOUT_COM_PRODUCTION_KEY = 'pk_m6yjih7mvailyyn4fmgunatoiao';
const CHECKOUT_COM_STAGING_KEY = 'pk_sbox_y67mbbuym66rphki3ktkvbjugmt';

export const getFramesConfig = ({
    billingPostcode,
    cardholderName
}: {
    billingPostcode: string;
    cardholderName: string;
}) => {
    return {
        publicKey:
            window.location.host === 'www.iwoca.co.uk'
                ? CHECKOUT_COM_PRODUCTION_KEY
                : CHECKOUT_COM_STAGING_KEY,
        cardholder: {
            name: cardholderName,
            billingAddress: { zip: billingPostcode }
        },
        localization: {
            cardNumberPlaceholder: '1234 1234 1234 1234',
            expiryMonthPlaceholder: 'MM',
            expiryYearPlaceholder: 'YY',
            cvvPlaceholder: 'CVC'
        },
        style: {
            base: {
                fontFamily: 'Aesop, sans-serif',
                height: '50px',
                fontSize: '18px',
                border: '1px solid #e9e9e9',
                padding: '13px'
            },
            focus: {
                borderColor: 'rgb(105, 159, 227)',
                borderWidth: '3px'
            },
            invalid: {
                color: 'rgb(175 13 4)'
            },
            placeholder: {
                base: {
                    color: '#8e8e8e'
                }
            }
        }
    } satisfies FramesInitProps;
};
